// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f4d92c9","732":"b8771d66"}[chunkId] + ".chunk.js";
};